import React from "react";
import { Link } from "react-router-dom";
import { Check, Sparkles, CalendarClock, Wallet } from "lucide-react";

export default function ForDoctors() {
  return (
    <div className="cm-container py-14">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="cm-eyebrow mb-2">For Doctors</div>
          <h1 className="cm-h2">Practice on your terms.</h1>
          <p className="cm-body mt-3">Join a trusted network of verified UK doctors. Set your availability, review AI-assisted briefs, and consult from anywhere.</p>
          <ul className="mt-6 space-y-3 text-sm text-[#475569]">
            <li className="flex items-start gap-2"><Check size={16} className="text-[#3daa6e] mt-0.5"/> AI-assisted patient briefs before every consult</li>
            <li className="flex items-start gap-2"><Check size={16} className="text-[#3daa6e] mt-0.5"/> Weekly recurring availability, holidays, buffers &mdash; all configurable</li>
            <li className="flex items-start gap-2"><Check size={16} className="text-[#3daa6e] mt-0.5"/> Earn up to £50 per consult &mdash; transparent per-consultation rates</li>
            <li className="flex items-start gap-2"><Check size={16} className="text-[#3daa6e] mt-0.5"/> Weekly payouts. Transparent earnings dashboard.</li>
          </ul>
          <div className="mt-8">
            <Link to="/register/doctor" className="cm-btn-primary" data-testid="fd-join-cta">Join as a doctor</Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="cm-card"><Sparkles size={20} className="text-[#4a90d9] mb-2"/><div className="font-semibold text-[#1a2b4a]">AI briefs</div><p className="text-xs text-[#475569] mt-1">Structured summaries before every appointment.</p></div>
          <div className="cm-card mt-6"><CalendarClock size={20} className="text-[#4a90d9] mb-2"/><div className="font-semibold text-[#1a2b4a]">Your schedule</div><p className="text-xs text-[#475569] mt-1">Weekly slots, holidays, max daily &mdash; all yours.</p></div>
          <div className="cm-card"><Wallet size={20} className="text-[#4a90d9] mb-2"/><div className="font-semibold text-[#1a2b4a]">Weekly payouts</div><p className="text-xs text-[#475569] mt-1">See earnings in real time. Paid weekly.</p></div>
          <div className="cm-card mt-6"><Check size={20} className="text-[#3daa6e] mb-2"/><div className="font-semibold text-[#1a2b4a]">Fully insured</div><p className="text-xs text-[#475569] mt-1">Platform-side indemnity &amp; compliance.</p></div>
        </div>
      </div>
    </div>
  );
}
